import React, { useState } from 'react';

const GridListBtn = () => {
  const tilesWrapperToggleClass = 'bra-prodTilesGrid--detail';
  const recipeWrapperToggleClass = 'dln-recipe-grid--detail';
  const tilesWrapper = document.querySelector('.bra-prodTilesGrid');
  const recipesWrapper = document.querySelector('.dln-recipe-grid');
  const [grid, setGrid] = useState(true);
  const toggleView = isGrid => {
    setGrid(isGrid);
    if (isGrid) {
      if (tilesWrapper != null) {
        tilesWrapper.classList.remove(tilesWrapperToggleClass);
      }
      if (recipesWrapper != null) {
        recipesWrapper.classList.remove(recipeWrapperToggleClass);
      }
    } else {
      if (tilesWrapper != null) {
        tilesWrapper.classList.add(tilesWrapperToggleClass);
      }
      if (recipesWrapper != null) {
        recipesWrapper.classList.add(recipeWrapperToggleClass);
      }
    }
  };
  return (
    <div className='bra-btnView'>
      <button
        className={`bra-btnView__button -grid ${grid && '-active'}`}
        type='button'
        onClick={() => toggleView(true)}
      >
        <i
          className='bra-icn bra-icn__grid-view'
          data-class=' bra-icn__grid-view'
        />
      </button>
      <button
        className={`bra-btnView__button -detail ${!grid ? '-active' : ''}`}
        type='button'
        onClick={() => toggleView(false)}
      >
        <i
          className='bra-icn bra-icn__list-view'
          data-class=' bra-icn__list-view'
        />
      </button>
    </div>
  );
};

export default GridListBtn;
